import React, { Fragment, FunctionComponent } from 'react';
import styles from './Asset.module.scss';
import { Icon, Typography } from 'components/elements';
import { Facebook, Linkedin, Twitter } from 'assets/icons';
import { WPAcfKnowledgeResource } from 'types/acf/knowledge';
import { FormattedText } from 'components/presentional';
import { useIntl } from 'react-intl';
import messages from 'messages/base-pl';
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'react-share';
import cx from 'clsx';
import DOMPurify from 'dompurify';

interface OwnProps {
  assetTitle?: string;
  assetDescription?: string;
  data: WPAcfKnowledgeResource | null;
}

type AssetProps = JSX.IntrinsicElements['div'] & OwnProps;

const Asset: FunctionComponent<AssetProps> = props => {
  const { className, ...rest } = props;
  const { formatMessage } = useIntl();
  const { data, assetTitle, assetDescription } = props;

  if (!data) {
    return null;
  }

  const { header, authors } = data;

  const wrapperClassNames = cx({
    [styles.wrapper]: true,
    ...(className && { [className]: true }),
  });

  return (
    <div className={wrapperClassNames} {...rest}>
      <div className={styles.container}>
        {assetTitle && (
          <Typography
            mobile="new_neue_semibold_26"
            tablet="new_neue_semibold_26"
            desktop="new_neue_32_h1"
            as="h2"
            className={styles.header}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(assetTitle) }}
          />
        )}
        {assetDescription && <FormattedText className={styles.description} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(assetDescription) }} />}
        {header && authors && authors.length && (
          <Fragment>
            <Typography className={styles.subheader} mobile="new_neue_20_h2" tablet="new_neue_20_h2" desktop="new_neue_20_h2" as="h4">
              {header}
            </Typography>
            <Typography className={styles.authors} mobile="new_ibm_regular_16" tablet="new_ibm_regular_16" desktop="new_ibm_regular_16" as="p">
              {authors.map((author, index) => (
                <p key={`asset-author-${index}`} className={styles.author}>
                  {author.name}
                </p>
              ))}
            </Typography>
          </Fragment>
        )}
        <Typography mobile="new_ibm_regular_16" tablet="new_ibm_regular_16" desktop="new_ibm_regular_16">
          <ul className={styles.links}>
            <li className={styles.link}>{formatMessage(messages.share_this)}</li>
            <li className={styles.link}>
              <FacebookShareButton url={window.location.href} quote={assetTitle}>
                <Icon size={36} icon={Facebook} />
              </FacebookShareButton>
            </li>
            <li className={styles.link}>
              <TwitterShareButton url={window.location.href} title={assetTitle}>
                <Icon size={36} icon={Twitter} />
              </TwitterShareButton>
            </li>
            <li className={styles.link}>
              <LinkedinShareButton url={window.location.href} title={assetTitle}>
                <Icon size={36} icon={Linkedin} />
              </LinkedinShareButton>
            </li>
          </ul>
        </Typography>
      </div>
    </div>
  );
};

export default Asset;
